namespace $ { $mol_style_attach( "mol/gallery/gallery.view.css",
 "[mol_gallery] {\n\tflex-wrap: wrap;\n\tflex: 1 1 auto;\n\talign-items: stretch;\n    align-content: stretch;\n}\n"
) }